import React, { PropTypes } from 'react';


let getRowClass = (fillerStats, target) => {
  let toAllocate = fillerStats.get("toAllocate");

  if (target > 0 && toAllocate === 0) {
    return "all-allocated";
  }

  if (target > 0 && toAllocate < 0) {
    return "over-allocated";
  }
}


class FillerTableRow extends React.Component {

  state = { isEdit_Name: false, isEdit_Target: false };

  changeName = () => {
    this.setState({ isEdit_Name: true });
  };

  changeTarget = () => {
    this.setState({ isEdit_Target: true });
  };

  changedName = () => {
    this.setState({ isEdit_Name: false });
    let fillerDef = { key: this.props.fillerStats.get("key"), name: this.name.value };
    this.props.setFiller({ fillerDef });
  };

  changedTarget = () => {
    this.setState({ isEdit_Target: false });
    let fillerDef = { key: this.props.fillerStats.get("key"), target: this.target.value };
    this.props.setFiller({ fillerDef });
  };


  // constructor(props) {
  //   super(props);
  // }



 render () {

  let colItemName, colTarget = null;

  if (!this.state.isEdit_Name) {
      colItemName = <td className="editable" onClick={this.changeName}>{this.props.name}</td>;
  } else {
      colItemName = <td><input type="text" 
                               className="form-control"
                               placeholder="Name..."
                               defaultValue={this.props.name}
                               onBlur={this.changedName}
                               ref={(input) => this.name = input} /></td>
  }

  if (!this.state.isEdit_Target) {
    colTarget = <td className="editable" onClick={this.changeTarget}>{this.props.target}</td>;
  } else {
    colTarget = <td><input type="number" 
                           className="form-control"
                           placeholder="Target number..."
                           defaultValue={this.props.target}
                           onBlur={this.changedTarget}
                           ref={(input) => this.target = input} /></td>
  }

  return (
    <tr className={getRowClass(this.props.fillerStats, this.props.target)}>
      {colItemName}
      {colTarget}
      <td>{this.props.fillerStats.get("allocated")}</td>
      <td>{this.props.fillerStats.get("toAllocate")}</td>
    </tr> );
  }

}



// const getFillerName = (key, fillers) => {
//   return fillers.get(key).name;
// }


export const CountTable = ({ fillersCounts, fillers, setFiller }) => {

  if (!(fillersCounts && fillersCounts.size > 0)) {
    return null;
  }

  return (
    <table className="table table-striped table-condensed table-bordered" id="counts-table">
      <thead>
        <tr>
          <th>Activity</th>
          <th>Target #</th>
          <th>In plan</th>
          <th>Remains to allocate</th>
        </tr>
      </thead>
      <tbody>
        {fillersCounts.entrySeq().map( ([key, fillerStats]) => {
          let fillerDef = fillers.get(key);
          return (
            <FillerTableRow key={key} 
                            name={fillerDef.name}
                            target={fillerDef.target}
                            fillerStats={fillerStats} 
                            setFiller={setFiller} />)
        })}
      </tbody>
    </table>
  )

}


/** WEBPACK FOOTER **
 ** ./web/static/js/react/presentationals/counts_table.js
 **/